import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box } from '@mui/system';

const ScrollButtons = React.forwardRef((props, ref: React.MutableRefObject<HTMLElement>) => {
    const step = 5;
    const isScrollRef = React.useRef();
    const scrollRef = ref;

    const setMove = (state) => (isScrollRef.current = state);

    const moveLeft = () => {
        if (isScrollRef.current) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollLeft + step;
            requestAnimationFrame(moveLeft);
        }
    };
    const moveRight = () => {
        if (isScrollRef.current) {
            scrollRef.current.scrollLeft = scrollRef.current.scrollLeft - step;
            requestAnimationFrame(moveRight);
        }
    };

    const scrollButton = (marginLeft?: string) => {
        return {
            marginLeft: `${marginLeft}`,
            width: '20px',
            height: '20px',
            backgroundColor: '#333D45'
        };
    };

    return (
        <Box
            sx={{
                width: '100px',
                padding: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <IconButton
                sx={scrollButton()}
                variant={'contained'}
                onMouseDown={() => {
                    setMove(true);
                    moveRight();
                }}
                onMouseUp={() => setMove(false)}
            >
                <ChevronLeft sx={{ color: 'white' }} />
            </IconButton>
            <IconButton
                ref={scrollRef}
                sx={scrollButton('15px')}
                variant={'contained'}
                onMouseDown={() => {
                    setMove(true);
                    moveLeft();
                }}
                onMouseUp={() => setMove(false)}
            >
                <ChevronRight sx={{ color: 'white' }} />
            </IconButton>
        </Box>
    );
});

export default ScrollButtons;
